import { getStructureTypeShortName } from './getStructureTypeShortName';

export const onStructureTypeCellRender = (e) => {
    if (e.data.structureTypeId === 0) {
        return 'Various';
    }
    if (!e.data.structureTypeId) {
        return '';
    }
    return getStructureTypeShortName(e.data.structureTypeId);
};
